// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__SXBoD","label":"default_label__kUtK4","field":"default_field__TICUY"};